module.exports = __webpack_public_path__ + "img/IMG_8629_T_L_Black_MockedUp.cf0d89f4.jpg";